<script>
import ModalBus from '@/eventBus'

export default {
  props: {
    isOpen: Boolean,
  },

  watch: {
    isOpen() {
      this.lockScroll()
    },
  },

  created() {
    this.lockScroll()
    document.addEventListener('keyup', this.handleKeyup)
  },

  beforeUnmount() {
    document.removeEventListener('keyup', this.handleKeyup)
  },

  methods: {
    close() {
      this.$emit('close')
      ModalBus.emit('close')
    },

    handleKeyup(e) {
      if (e.keyCode === 27) this.$emit('close')
    },

    lockScroll: function () {
      document.body.style.overflow = this.isOpen ? 'hidden' : 'unset'
    },
  },
}
</script>

<template>
  <transition name="fade">
    <div
      v-show="isOpen"
      class="Modal"
      @click="close">
      <div class="Modal__wrapper">
        <div
          class="relative flex h-full max-h-screen w-full flex-col items-center justify-center lg:py-8"
          @click.stop>
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter .Modal__wrapper,
.fade-leave-to .Modal__wrapper {
  transform: translateY(-20%);
}

.Modal__wrapper {
  transition: 0.5s;
}
</style>
